"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var TagView = {
  name: 'TagView',
  props: ['menuData'],
  data: function data() {
    return {
      tagViews: [],
      current: ''
    };
  },
  created: function created() {
    var menuData = this.menuData;
    var homePath = (0, _lodash.default)(menuData, '[0].path', '/dashboard');
    var homeTitle = (0, _lodash.default)(menuData, '[0].meta.title', 'home');
    var _this$$route = this.$route,
        title = _this$$route.meta.title,
        path = _this$$route.path; // home

    if (homePath === path) {
      this.tagViews = [{
        path: homePath,
        title: homeTitle
      }];
    } else {
      this.tagViews = [{
        path: homePath,
        title: homeTitle
      }, {
        path: path,
        title: title
      }];
    }

    this.setCurrent(title);
  },
  watch: {
    $route: function $route(_ref) {
      var path = _ref.path,
          title = _ref.meta.title;
      var tagViews = this.tagViews;
      var index = this.getViewsIndex(path);

      if (index === -1) {
        this.$set(this.tagViews, tagViews.length, {
          path: path,
          title: title
        });
      }

      this.setCurrent(title);
    }
  },
  render: function render() {
    var h = arguments[0];
    var tagViews = this.tagViews,
        tabRemove = this.tabRemove,
        tabClick = this.tabClick,
        current = this.current;
    var tabs = [];
    tagViews.forEach(function (item, index) {
      tabs.push(h("el-tab-pane", {
        "attrs": {
          "closable": index !== 0,
          "label": item.title,
          "name": item.title
        },
        "key": item.path
      }));
    });
    return h("el-tabs", {
      "class": "tag-view",
      "attrs": {
        "value": current,
        "type": "card"
      },
      "on": {
        "tab-remove": tabRemove,
        "tab-click": tabClick
      }
    }, [tabs]);
  },
  methods: {
    setCurrent: function setCurrent(title) {
      this.current = title;
    },
    getViewsIndex: function getViewsIndex(value) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'path';
      return this.tagViews.findIndex(function (item) {
        return item[type] === value;
      });
    },
    tabRemove: function tabRemove(name) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tagViews, getViewsIndex, index;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                tagViews = _this.tagViews, getViewsIndex = _this.getViewsIndex;
                index = getViewsIndex(name, 'title');

                if (!(index > -1)) {
                  _context.next = 7;
                  break;
                }

                tagViews.splice(index, 1);
                _context.next = 6;
                return _this.$nextTick();

              case 6:
                _this.$router.push(tagViews[tagViews.length - 1].path);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    tabClick: function tabClick(_ref2) {
      var index = _ref2.index;
      var tagViews = this.tagViews;
      this.$router.push(tagViews[index].path);
    }
  }
};
var _default = TagView;
exports.default = _default;